import { prependRoot } from "../util/prependRoot.js";
import { getApiRoot } from "../store/configureStore.js";
import axios from "axios";

const routePrefix = "/indienen/";

const IndienenApi = {
    get(dossierId) {
		const serviceUrl = prependRoot(routePrefix + dossierId, getApiRoot());
		let returnValue = axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},

	confirm(dossierId) {
		const serviceUrl = prependRoot(routePrefix + "confirm/" + dossierId, getApiRoot());
		let returnValue = axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},

	generatePdf(dossierId) {
		const serviceUrl = prependRoot(routePrefix +"pdf/"+ dossierId, getApiRoot());
		let returnValue = axios.post(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	}
};

export default IndienenApi;
